import "./Footer.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Accordion } from "react-bootstrap";
import { useState } from "react";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import {ContactFormModal, ModalMessage} from "../../components";

export default function Footer(props) {
  // footer with background image, menu items and copyright message

  const categories = useSelector((state) => state.categories);
  const { address, storeName, phone, footerImage } = useSelector(
    (state) => state.appConfig
  );
  const {isAdmin} = useSelector((state) => state.user);

  const [showContactForm, setShowContactForm] = useState(false); 
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  return (
    <footer
      style={{
        backgroundImage: `url(${footerImage?.url})`,
      }}
    >
      <Container fluid className="footer-container">
      {errorMsg && (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        /> 
      )} 
      {successMsg && (
        <ModalMessage
          autoClose={true}
          type="success"
          message={successMsg}
          setSuccessMsg={setSuccessMsg}
        />)
      }
      {/* CONTACT FORM */}
      {showContactForm && <ContactFormModal setShowContactForm={setShowContactForm} setErrorMsg={setErrorMsg} setSuccessMsg={setSuccessMsg}/>}
        <Row className="mt-5 justify-content-center">
          <Col lg={8} className="text-white text-center">
            <div className="mt-3">
              <Accordion
                defaultActiveKey={0}
                flush
                className="footer-accordion"
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="footer-accordion-header" >CATEGORIES </Accordion.Header>
                  <Accordion.Body className="footer-accordion-body">
                    {categories &&
                      categories.length > 0 &&
                      categories.map((category) => {
                        return (
                          <LinkContainer
                            key={category._id}
                            to={`product-list/category/${category?._id}`}
                            className="footer-link"
                          >
                            <p>{category?.name}</p>
                          </LinkContainer>
                        );
                      })}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>

            <div className="mt-3">
              <Accordion
                defaultActiveKey={0}
                flush
                className="footer-accordion"
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="footer-accordion-header">SUPPORT </Accordion.Header>
                  <Accordion.Body style={{ backgroundColor: "#00000078" }}>
                    <div>
                        <p onClick={props?.toggleChatWindow} style={{cursor: "pointer"}}                      className="footer-link" >Live Chat {isAdmin && <span style={{fontSize: "small", fontStyle: "italic"}}>(not available in admin mode)</span>}</p>
                      <p onClick={() => setShowContactForm(true)} className="footer-link">Contact Form</p>
                      {phone && (
                        <p>
                          {phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}
                        </p>
                      )}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            <div className="mt-3">
              {/* Address */}
              <Accordion
                defaultActiveKey={0}
                flush
                className="footer-accordion"
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="footer-accordion-header">ADDRESS </Accordion.Header>
                  <Accordion.Body style={{ backgroundColor: "#00000078" }}>
                    {address && (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <span>{address?.street},</span>&nbsp;
                        <span>{address?.city},</span>&nbsp;
                        <span>{address?.province}</span>&nbsp;
                        <span>{address?.postalCode}</span>
                      </div>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>

            {storeName && <p className="mt-4"><span>&copy;</span> <span className="logo">{storeName}</span></p>}
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
